export abstract class Fabricator<T extends any> {
  protected getBase!: () => T

  protected setters: ((value: T) => T)[] = []

  get() {
    let base = this.getBase()
    for (const setter of this.setters) {
      base = setter(base)
    }
    return base
  }

  mutate(mutator: (value: T) => T) {
    this.setters.push(mutator)
    return this
  }
}
